import abl from '../abl';
import _ from 'underscore';
import constants from '../constants/index';
import normalize from '../lib/normalize';

const instructionalLayers = abl.config.feature_flags.core_vs_noncore_layers ?
[
  { 
    id: 'core_instructional',
    name: 'Instructional (Core)',
    className: 'abl-layers-core-instructional-border',
    selectedClass: 'abl-layers-core-instructional', 
    conditions: {
      meeting: { instructional: true, core: true }
    }
  },
  { 
    id: 'non_core_instructional',
    name: 'Instructional (Non-Core)',
    className: 'abl-layers-non-core-instructional-border',
    selectedClass: 'abl-layers-non-core-instructional', 
    conditions: {
      meeting: { instructional: true, core: false }
    }
  }
] :
[
  { 
    id: 'instructional',
    name: 'Instructional',
    className: 'abl-layers-instructional-border',
    selectedClass: 'abl-layers-instructional', 
    conditions: {
      meeting: { instructional: true }
    }
  }
];

let defaultState = normalize({
    selected: ['available', 'non-instructional']
  }, instructionalLayers.concat([
  { 
    id: 'prep',
    name: 'Prep/Plan',
    className: 'abl-layers-prep-border',
    selectedClass: 'abl-layers-prep', 
    conditions: {
      meeting: { type: 'Prep' }
    }
  },
  { 
    id: 'duty',
    name: 'Duty',
    className: 'abl-layers-duty-border',
    selectedClass: 'abl-layers-duty', 
    conditions: {
      meeting: { type: 'Duty' }
    }
  },
  {
    id: 'available',
    name: 'Available',
    className: 'abl-layers-available-border',
    selectedClass: 'abl-layers-available',
    conditions: {
      scheduledMeeting: { scheduled: false }
    }
  },
  { 
    id: 'non-instructional',
    name: 'Non-Instructional',
    className: 'abl-layers-noninstructional-border',
    selectedClass: 'abl-layers-noninstructional',
    conditions: {
      meeting: { noninstructional: true },
      scheduledMeeting: { scheduled: true }
    }
  }
]));

export default function meetingLayersReducer(state = defaultState, action) {
  let newState = state;

  switch(action.type) {
    case constants.SELECT_MEETING_LAYER:
      newState = Object.assign({}, newState);
      if(action.payload.selected) {
        newState.selected = newState.selected.concat(action.payload.id);
      }
      else {
        newState.selected = _.without(newState.selected, action.payload.id);
      }
      break;
    default:
  }
  return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/meeting_layers_reducer.js
 **/